import { Grid } from "@mantine/core"
import { Icons } from "src/components/ui/Icons"
import { LinkCard } from "src/components/ui/LinkCard"

export const TalentAdminLinkCards = () => {

    return (
        <Grid mt="sm">  
            <Grid.Col span={12}>
                <LinkCard 
                    label="Bookings"
                    icon={Icons.booking} 
                    to={"/bookings"} 
                    color={"yellow"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Calendar"
                    icon={Icons.calendar} 
                    to={"/calendar"} 
                    color={"blue.6"}
                />
            </Grid.Col>
            <Grid.Col span={6}>
                <LinkCard 
                    label="Documents"
                    icon={Icons.files} 
                    to={"/documents"} 
                    color={"green.8"}
                />
            </Grid.Col>
        </Grid>
    )
}